import React from 'react';
import { clsx } from 'clsx';

export function GradientFrame({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'relative p-[2px] rounded-3xl',
        'bg-gradient-to-br from-[#d65c30]/60 via-[#1a3b5c]/60 to-[#0d273d]/60',
        'shadow-[0_0_25px_-5px_#d65c3044]',
        className
      )}
    >
      <div
        className="relative rounded-[22px] overflow-hidden
                   bg-gradient-to-b from-[#1a3b5c] to-[#0d273d]"
      >

        <div
          className="pointer-events-none absolute top-0 left-0 right-0 h-32
                     bg-gradient-to-b from-[#d65c30]/20 via-[#d65c30]/8 to-transparent
                     blur-2xl"
        />

        {children}
      </div>
    </div>
  );
}
